import DOMPurify from "dompurify";
import React, { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import "./index.css";

const BroadcastModal = (props) => {
  const { message, submitting, onDismiss, onAcknowledge } = props;
  const isAcknowledge = message?.type === "acknowledge";
  const [checked, setChecked] = useState(false);

  // Reset the checkbox whenever a new message is shown.
  useEffect(() => {
    setChecked(false);
  }, [message?.id]);

  return (
    <Modal
      show
      centered
      dialogClassName="broadcastDialog"
      keyboard={!isAcknowledge}
      backdrop={isAcknowledge ? "static" : true}
      onHide={isAcknowledge ? undefined : () => onDismiss({ id: message?.id })}
    >
      <Modal.Header closeButton={!isAcknowledge}>
        <Modal.Title className="C-primary modalHeader text-truncate bold">
          {message?.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          className="broadcastContent"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(message?.content || ""),
          }}
        />
        {isAcknowledge && (
          <label className="broadcastCheckLabel" htmlFor="broadcastAcknowledgeCheck">
            <input
              className="form-check-input broadcastCheckInput"
              type="checkbox"
              id="broadcastAcknowledgeCheck"
              style={{ padding:'1px' }}
              checked={checked}
              disabled={submitting}
              onChange={(e) => setChecked(e.target.checked)}
            />
            I have read and agree to these terms
          </label>
        )}
      </Modal.Body>
      <Modal.Footer>
        {isAcknowledge ? (
          <Button
            variant="primary pressable"
            disabled={!checked || submitting}
            onClick={() => onAcknowledge({ id: message?.id })}
          >
            {submitting && (
              <Spinner animation="border" size="sm" className="me-2" />
            )}
            Accept
          </Button>
        ) : (
          <Button
            variant="primary pressable"
            disabled={submitting}
            onClick={() => onDismiss({ id: message?.id })}
          >
            {submitting && (
              <Spinner animation="border" size="sm" className="me-2" />
            )}
            Dismiss
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default BroadcastModal;
